/**
 * EnergyFlowChart - Custom tooltip for energy flow charts.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { vortxTypography } from '@vortx/shared-ui';
import { COLORS } from './ResultsDesignTokens';

// Custom chart tooltip
export const ChartTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;

    return (
        <Box sx={{
            bgcolor: 'rgba(8, 8, 12, 0.95)',
            border: `1px solid ${alpha(COLORS.accent, 0.4)}`,
            borderRadius: 1,
            p: 1.5,
            boxShadow: `0 8px 32px rgba(0,0,0,0.6), 0 0 30px ${alpha(COLORS.accent, 0.15)}`,
        }}>
            <Typography sx={{
                fontFamily: vortxTypography.mono,
                fontSize: '0.8rem',
                color: COLORS.text.primary,
                fontWeight: 600,
                mb: 1,
                borderBottom: `1px solid ${alpha(COLORS.accent, 0.2)}`,
                pb: 0.5,
            }}>
                {label}
            </Typography>
            {payload.map((entry, i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.25 }}>
                    <Box sx={{
                        width: 10,
                        height: 10,
                        borderRadius: 1,
                        bgcolor: entry.color,
                        boxShadow: `0 0 6px ${entry.color}`,
                    }} />
                    <Typography sx={{
                        fontFamily: vortxTypography.mono,
                        fontSize: '0.75rem',
                        color: entry.color,
                        fontWeight: 600,
                    }}>
                        {entry.name}: {entry.value?.toFixed(1)} kW
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
